import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TableLazyLoadEvent } from 'primeng/table';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MenuItem } from 'primeng/api';
// migrated 1:1 from @nexato/nx-core-module (#682)
import { NXDataSourcePrime } from '../../../services/dataSource/NXDataSourcePrime';
import { IssueType } from '../../../entities/issue/issue-type';
import { Observable, of, switchMap, take } from 'rxjs';
import { ApolloService } from '../../../services/apollo.service';
import * as fromGraphQl from './graphql';
import { Reloadable } from '../../../services/command/command.service';
import { IssueTypesDataSource } from './issue-types.datasource';

@Component({
  selector: 'app-issue-types',
  templateUrl: './issue-types.component.html',
  styleUrls: ['./issue-types.component.scss']
})
export class IssueTypesComponent implements OnInit, Reloadable {

  dialogRef: DynamicDialogRef | undefined;

  public sortProperty: string;
  public defaultSortProperty: string = 'id';
  public sortDirection: string;
  public defaultSortDirection: string = 'asc';
  public pageNumber = 0;
  public pageSize = 15;
  // public sortModel = { label: 'Keine Sortierung', fieldName: 'id', direction: "asc" };
  // public sortOptions = [
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.noSorting', fieldName: 'id', direction: "asc" },
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.lastTriggeredDateTimeDesc', fieldName: 'lastTriggeredDateTime', direction: "desc" },
  //   { label: 'coreModuleModule.subscriptionsComponent.list.sorting.lastTriggeredDateTimeAsc', fieldName: 'lastTriggeredDateTime', direction: "asc" }
  // ];

  public dataSource: IssueTypesDataSource;
  public loading = false;
  public menuItems: MenuItem[] = [];
  public issueTypes: IssueType[];
  public selectedIssueType: IssueType | undefined;

  public customHeadersArray: Array<{ name: string, value: string }>;

  public reloadable = this;

  // ace config so that it only takes the hight of the content
  editorConfig = {
    maxLines: Infinity,
    highlightActiveLine: false,
    highlightGutterLine: false
  }

  constructor(
    private apollo: Apollo,
    @Inject('env') public environment: any,
    private cdRef: ChangeDetectorRef,
    private apolloService: ApolloService
  ) {
  }

  reload(): void {

  }

  ngOnInit(): void {
    this.dataSource = new IssueTypesDataSource(this.apollo, this.environment, this);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadIssueTypes({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
    });
  }

  refetchEvents(): void {

  }

  loadData(event: TableLazyLoadEvent) {
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    // pagination
    this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
    this.pageSize = event?.rows !== undefined ? event.rows : 15;

    this.refetchEvents();
  }

  sort(event: any) {
    if (event?.value?.direction && event?.value?.fieldName) {
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }

  copyToClipboard(stringToCopy: string): void {
    navigator.clipboard.writeText(stringToCopy);
  }


  setMenuItems(): void {
    this.menuItems = [];
    // todo -> command
  }

  public getIssueTypes(): Observable<IssueType[]> {
    return this.apolloService.query<fromGraphQl.IssueTypesQueryResponse>(fromGraphQl.ISSUETYPES_QUERY)
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( IssueType.createIssueTypes(result.data.issueTypes));
        })
      );
  }


}

